import { Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';
import { CheckIcon } from '@change/ds-icons/CheckIcon';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

export const ReportAbuseConfirmModal: React.FC<ReportAbuseConfirmModalProps> = ({ isOpen, onOpenChange }) => {
	const { translate } = useI18n();
	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			size="small"
			className="z-2010"
			onClose={() => {}}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			data-qa="report-abuse-confirm-modal"
		>
			<ModalHeader
				title={
					<Text variant="heading" fontWeight="bold" size="small">
						<Translate value="fe.components.petition_report_abuse.form_title" />
					</Text>
				}
			/>
			<ModalBody>
				<div className="flex items-start">
					<CheckIcon size="x-small" className="mr-2 translate-y-0.5" />
					<Text>
						<Translate value="fe.components.petition_report_abuse.form_confirmation" />
					</Text>
				</div>
			</ModalBody>
		</Modal>
	);
};

type ReportAbuseConfirmModalProps = Readonly<{
	isOpen: boolean;
	onOpenChange: (isOpen: boolean) => void;
}>;
